export class Logon {
    public Uid: string; 
    public Pwd: string;

    public IP: string;

    constructor() {
        this.IP = "http://127.0.0.1:/"
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/config/logon.ts
 **/